import React, { useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { HiOutlineMenuAlt4 } from 'react-icons/hi';
import { handleScroll } from '../components/helper/scroll'

const Navbar = ({mainRef, aboutRef, usageRef}) => {
  const [nav, setNav] = useState(false);
  const [logo, setLogo] = useState(false)
  const handleNav = () => {
    setNav(!nav);
    setLogo(!logo)
  };

  return (
    <div className='flex w-full justify-between items-center h-20 px-4 absolute z-10 text-white'>
      <div>
        <h1 onClick={handleNav} className={logo ? 'hidden' : 'block'}>BALIFATHER</h1>
      </div>
      <ul className='hidden md:flex flex-auto justify-center ml-[-12%]'>
        <li onClick={() => {
            handleScroll(mainRef.current);
          }} className='cursor-pointer'>Hidden Place</li>
        <li
        onClick={() => {
          handleScroll(aboutRef.current);
        }} className='cursor-pointer'>Private Trip</li>
        <li
        onClick={() => {
          handleScroll(usageRef.current);
        }} className='cursor-pointer'>All Gems</li>
      </ul>

      {/* Hamburger */}
      <div onClick={handleNav} className='md:hidden z-10'>
        {nav ? <AiOutlineClose className='text-black' size={20} /> : <HiOutlineMenuAlt4 size={20} />}
      </div>

      {/* Mobile menu dropdown */}
      <div onClick={handleNav} className={nav ? 'absolute text-black left-0 top-0 w-full bg-gray-100/90 px-4 py-7 flex flex-col' : 'absolute left-[-100%]'}>
        <ul>
          <h1>BALIFATHER</h1>
          <li onClick={() => {
            handleScroll(mainRef.current);
          }} className='cursor-pointer'>Hidden Place</li>
        <li
        onClick={() => {
          handleScroll(aboutRef.current);
        }} className='cursor-pointer'>Private Trip</li>
        <li
        onClick={() => {
          handleScroll(usageRef.current);
        }} className='cursor-pointer'>All Gems</li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
